import { z } from '@bonanza-social/toolkit/api';

const GameSchema = z.object({
  id: z.number(),
  name: z.string(),
});

const FreeSpinsSchema = z.object({
  playerId: z.number(),
  rewardedAt: z.string().datetime(),
  totalFreeSpinsCount: z.number(),
  freeSpinsLeft: z.number(),
  games: z.array(GameSchema),
});

export type FreeSpin = z.infer<typeof FreeSpinsSchema>;

export const FreeSpinsResponseSchema = z.array(FreeSpinsSchema);

export type FreeSpins = z.infer<typeof FreeSpinsResponseSchema>;
